<template>
  <div class="container-fluid p-0">
    <PageTitle
      :title="$t('coralSol.manejos')"
      :titleAdd="$t('management.addManejo')"
      :isAdd="true"
      :hasExportCSV="true"
      @onExportCSV="exportCSV"
    />

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
            <CoralsolManejosTable @orderBy="orderBy" @search="search" :items="items"/>
          </div>
        </div>
      </div>
    </div>
    <!-- /tabela -->
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import CoralsolManejosTable from './CoralsolManejosTable.vue'

export default {
  name: 'CoralsolManejos',
  components: { CoralsolManejosTable, PageTitle },
  data () {
    return {
      items: [],
      dataOrderBy: {}
    }
  },
  methods: {
    async exportCSV () {
      this.$store.dispatch('showPreload')

      // Parâmetros da busca (pode incluir filtros de formSearch)
      const params = {
        ...this.$store.state.formSearch,
        Page: this.$store.state.currentPage,
        PageSize: 9999
      }

      try {
        const response = await axios.get('/CoralsolManagement/getlistforexport', { params })

        const data = response.data.items

        if (!data || !data.length) {
          this.$toasted.global.defaultError({ msg: 'Nenhum dado encontrado para exportação.' })
          return
        }

        const labels = {
          management_id: 'ID',
          date: 'Data',
          observer: 'Observador',
          locality_name: 'Localidade',
          surname: 'Colaborador',
          number_of_divers: 'Nº de Mergulhadores',
          number_of_cylinders: 'Nº de Cilindros',
          number_of_colonies: 'Nº de Colônias',
          method: 'Método',
          managed_mass_kg: 'Massa Gerenciada (kg)',
          observation: 'Observações',
          management_coords: 'Coordenadas do Manejo',
          occurrences_managed: 'Ocorrências Manejadas'
        }

        const headers = Object.values(labels).join(';')

        const rows = data.map(item => {
          return Object.keys(labels).map(key => {
            const value = item[key]
            return typeof value === 'string'
              ? `"${value.replace(/"/g, '""')}"`
              : value != null ? value : ''
          }).join(';')
        })

        const csv = `${headers}\n${rows.join('\n')}`

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'manejos_export.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toasted.global.defaultSuccess({ msg: 'Exportação concluída!' })
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao exportar os dados.' })
        console.error('Erro exportCSV:', error)
      } finally {
        this.$store.dispatch('hidePreload')
      }
    },
    clear () {
      this.$store.commit('clearFormSearch')
    },
    orderBy (dataOrderBy) {
      this.$store.state.dataOrderBy = dataOrderBy
      this.search()
    },
    setFormOrderBy () {
      this.$store.state.formSearch.OrderByIDAcs = this.$store.state.dataOrderBy.OrderByIDAcs
      this.$store.state.formSearch.OrderByIDDesc = this.$store.state.dataOrderBy.OrderByIDDesc
      this.$store.state.formSearch.OrderByManagementCoordsAcs = this.$store.state.dataOrderBy.OrderByManagementCoordsAcs
      this.$store.state.formSearch.OrderByManagementCoordsDesc = this.$store.state.dataOrderBy.OrderByManagementCoordsDesc
      this.$store.state.formSearch.OrderByDateAcs = this.$store.state.dataOrderBy.OrderByDateAcs
      this.$store.state.formSearch.OrderByDateDesc = this.$store.state.dataOrderBy.OrderByDateDesc
      this.$store.state.formSearch.LocalityIDAcs = this.$store.state.dataOrderBy.LocalityIDAcs
      this.$store.state.formSearch.LocalityIDDesc = this.$store.state.dataOrderBy.LocalityIDDesc
      this.$store.state.formSearch.OrderByManagedMassKgAcs = this.$store.state.dataOrderBy.OrderByManagedMassKgAcs
      this.$store.state.formSearch.OrderByManagedMassKgDesc = this.$store.state.dataOrderBy.OrderByManagedMassKgDesc
    },
    async search () {
      this.$store.dispatch('showPreload')

      this.setFormOrderBy()
      const params = this.$store.state.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      await axios.get('/CoralsolManagement/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    }
  },
  async created () {
    this.$store.state.formSearch.pending_analysis = true
    await this.search()
  }
}
</script>
